angular.module('cvsApp').directive('onlyNumber', function () {
        return {
          restrict: 'A',
          require: 'ngModel',
          link: function(scope, element, attrs,modelVal) {

            function inputText(userInput) { 
              if (userInput) {
                var editedInput = userInput.replace(/[^0-9]/g, ''); 
                if(userInput!==editedInput){
                  modelVal.$setViewValue(editedInput);
                  modelVal.$render();
                  return editedInput;
                }
                return editedInput;
              }
           }
          modelVal.$parsers.push(inputText);
        }
      };
    });

